import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ApiService } from '../../../shared/services';
import { AddPaintColorDialogComponent } from './add-paint-color-dialog/add-paint-color-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-room-specs',
  templateUrl: './room-specs.component.html',
  styleUrls: ['./room-specs.component.less']
})
export class RoomSpecsComponent implements OnInit {
  @Input() isHandset: boolean = false;
  @Input() roomId: string = '';

  selectionChoiceList: any[] = []
  selectionChoice = '';
  filteredChoiceOptions: any[] = [];
  choiceList: any[] = [];
  uniqueSelectionChoices: any[] = [];
  searchCtrl = new FormControl('');
  previewVisible = false;
  previewImage = '';
  originalResults: any[] = [];
  loading: boolean = false;
  paintApplications: { id: number, name: string }[] = [];
  paintFinishes: { id: number, name: string }[] = [];
  paintRecommendations: any[] = [];
  editingField: 'application' | 'finish' | 'comments' | null = null;
  editingRecommendationId: number | string | null = null;
  commentsDraft = '';
  savingKey = '';

  constructor(private api: ApiService, private dialog: MatDialog,
    private snackbar:MatSnackBar
  ) { }

  ngOnInit(): void {
       this.getPaintRecommendations();
    this.searchCtrl.valueChanges.pipe(debounceTime(300)).subscribe(searchText => {
      if (searchText && searchText.length >= 2) {
        this.loading = true;
        this.api.paintSearch(searchText, 25).subscribe(
          (data: any) => {
            this.loading = false;
            this.originalResults = JSON.parse(JSON.stringify(data.results));
            this.filteredChoiceOptions = data.results;
            console.log('Search data.results:', data.results);
          }, err => {
            this.loading = false;

          }
        );
      }
    });
    this.getPaintApplications();
    this.getPaintFinishes();
  }

  getPaintRecommendations() {
    this.api.getPaintRecommendations(this.api.roomId).subscribe((resp: any) => {
      this.paintRecommendations = resp.results || [];
    })
  }

  getPaintApplications() {
    this.api.getPaintApplications().subscribe((resp: any) => {
      this.paintApplications = resp?.data;
    })
  }
  getPaintFinishes() {
    this.api.getPaintFinishes().subscribe((resp: any) => {
      this.paintFinishes = resp?.data;
    })
  }

  openPaintColorDialog(paintColor: any) {
    const dialogRef = this.dialog.open(AddPaintColorDialogComponent,
      {
        width: '574px', maxWidth: '95vw', panelClass: 'add-paint-color-panel',
        data: {
          paintColor, paintApplications: this.paintApplications,
          paintFinishes: this.paintFinishes
        }
      });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getPaintRecommendations();
        // this.addPaintRecommendation(result);
      }
    });
  }

  // addPaintRecommendation(result: any) {
  //   // const paintColor = result.paintColor || {};
  //   // this.paintRecommendations = [{
  //   //   color_name: paintColor.color_name,
  //   //   color_code: paintColor.color_code,
  //   //   brand: paintColor.brand,
  //   //   application: this.getOptionLabel(result.application),
  //   //   finish: this.getOptionLabel(result.finish),
  //   //   comments: result.comments || 'Use on all walls except trim and ceiling.',
  //   //   color_family: paintColor.color_family,
  //   //   approx_lrv: paintColor.approx_lrv,
  //   //   status: 'Proposed',
  //   //   hex_code: paintColor.hex_code,
  //   //   source_url: paintColor.source_url
  //   // }, ...this.paintRecommendations];
  // }

  getOptionLabel(option: any): string {
    if (!option) {
      return '';
    }
    if (typeof option === 'string') {
      return option;
    }
    return option.name || option.label || option.value || option.application || option.finish || option.title || '';
  }

  getRecommendationId(recommendation: any): number | string {
    return recommendation?.recommendation_id || recommendation?.id || recommendation?.paint_recommendation_id;
  }

  getPaintSwatchStyles(hexCode: string): { [key: string]: string } {
    const backgroundColor = this.getPaintBackgroundColor(hexCode);
    const textColor = this.getContrastTextColor(backgroundColor);

    return {
      'background-color': backgroundColor,
      color: textColor,
      // 'text-shadow': textColor === '#FFFFFF' ? '0 1px 2px rgba(0,0,0,0.35)' : 'none'
    };
  }

  private getPaintBackgroundColor(hexCode: string): string {
    const fallbackColor = '#9f604f';
    const color = (hexCode || '').toString().trim();

    return /^#?[0-9a-fA-F]{6}$/.test(color) ? color : fallbackColor;
  }

  private getContrastTextColor(hexCode: string): string {
    const hex = hexCode.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    return brightness > 160 ? '#1F2937' : '#FFFFFF';
  }

  isEditing(recommendation: any, field: 'application' | 'finish' | 'comments'): boolean {
    return this.editingRecommendationId === this.getRecommendationId(recommendation) && this.editingField === field;
  }

  startEdit(recommendation: any, field: 'application' | 'finish' | 'comments') {
    if (this.savingKey) {
      return;
    }
    this.editingRecommendationId = this.getRecommendationId(recommendation);
    this.editingField = field;
    if (field === 'comments') {
      this.commentsDraft = recommendation.comments || '';
    }
  }

  cancelEdit() {
    this.editingRecommendationId = null;
    this.editingField = null;
    this.commentsDraft = '';
  }

  saveDropdownField(recommendation: any, field: 'application' | 'finish', value: string) {
    if (!value || value === recommendation[field]) {
      this.cancelEdit();
      return;
    }
    this.updatePaintRecommendation(recommendation, { [field]: value });
  }

  saveComments(recommendation: any) {
    if ((this.commentsDraft || '') === (recommendation.comments || '')) {
      this.cancelEdit();
      return;
    }
    this.updatePaintRecommendation(recommendation, { comments: this.commentsDraft || '' });
  }

  updatePaintRecommendation(recommendation: any, changes: any) {
    const recommendationId = this.getRecommendationId(recommendation);
    if (!recommendationId) {
      return;
    }

    const payload = {
      recommendation_id: recommendationId,
      application: changes.application || recommendation.application,
      finish: changes.finish || recommendation.finish,
      comments: changes.hasOwnProperty('comments') ? changes.comments : recommendation.comments
    };
    const key = `${recommendationId}-${Object.keys(changes)[0]}`;
    this.savingKey = key;

    this.api.updatePaintRecommendation(payload).subscribe((resp: any) => {
      Object.assign(recommendation, payload, resp?.data || resp?.result || {});
      recommendation.id = recommendation.id || recommendationId;
      this.savingKey = '';
      this.cancelEdit();
      // if(resp.success){
        this.snackbar.open(resp.message, 'x', {duration:5000})
      // }
    }, () => {
      this.savingKey = '';
        this.snackbar.open('Failed to update', 'x', {duration:5000})

    });
  }

}
